import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const Ticket: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M12.5 5H2.5C1.80964 5 1.25 5.55964 1.25 6.25V7.56251C2.6764 7.85206 3.75 9.11315 3.75 10.625C3.75 12.1368 2.6764 13.3979 1.25 13.6875V15C1.25 15.6904 1.80964 16.25 2.5 16.25H12.5L12.5 5ZM13.75 16.25H17.5C18.1904 16.25 18.75 15.6904 18.75 15V13.6875C17.3236 13.3979 16.25 12.1368 16.25 10.625C16.25 9.11315 17.3236 7.85206 18.75 7.56251V6.25C18.75 5.55964 18.1904 5 17.5 5H13.75L13.75 16.25Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default Ticket;